// Server enrichment output isn't guaranteed to be an array and may carry entries
// with no primary label, so callers must never render it raw. Generic so any
// feature showing a bullet list shares one guard instead of re-implementing it.
export const getSafeBullets = <T extends { primary?: unknown }>(
  bullets?: T[] | null
): T[] =>
  Array.isArray(bullets) ? bullets.filter((bullet) => bullet?.primary) : [];
